import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

export const MovementCompanyRenderer = ({ data }) => {
  const { colors } = useTheme();
  const movement = data?.original;

  if (movement?.isSkeleton) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={48}
        viewBox="0 0 400 48"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="8" y="16" rx="3" ry="3" width="100" height="12" />
      </ContentLoader>
    );
  }

  const organization = movement?.organization;
  const companyName = organization?.name || movement?.companyName || '';

  if (!companyName) {
    return (
      <Flex p="8px" alignItems="center" sx={{ height: '100%' }}>
        <Text fontSize="14px" color="text.subtle">
          -
        </Text>
      </Flex>
    );
  }

  return (
    <Flex
      p="8px"
      alignItems="center"
      sx={{
        height: '100%',
        gap: '4px',
      }}
    >
      {organization?.logoUrl && (
        <Box width="16px" height="16px" flex="0 0 auto">
          <ProfilePicture
            sx={{
              minWidth: '16px',
              minHeight: '16px',
            }}
            variant="square"
            imageUrl={organization.logoUrl || ''}
            name={companyName}
          />
        </Box>
      )}
      <Text
        fontSize="14px"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {companyName}
      </Text>
    </Flex>
  );
};

MovementCompanyRenderer.propTypes = {
  data: PropTypes.object,
};

MovementCompanyRenderer.defaultProps = {
  data: {},
};
